<ng-container *ngrxLet="selectedPlan$ as selectedPlan">
  <div class="plans__header">
    <div
      class="plan"
      [class.plan--selected]="selectedPlan === plan"
      (click)="selectPlan(plan)"
      *ngFor="let plan of plans"
    >
      <p class="plan__title">
        {{
          '+INSTALLATIONS.INSTALLATION.VICARE_PLANS.' + plan.plan + '.TITLE' | uppercase | translate
        }}
      </p>
      <div class="plan__footer">
        <div class="plan__pill" [class.plan__pill--inactive]="!plan.active">
          {{
            (plan.isDefault
              ? '+INSTALLATIONS.INSTALLATION.VICARE_PLANS.ACTIVE'
              : plan.active
              ? '+INSTALLATIONS.INSTALLATION.VICARE_PLANS.ACTIVE'
              : '+INSTALLATIONS.INSTALLATION.VICARE_PLANS.INACTIVE'
            ) | translate
          }}
        </div>
      </div>
    </div>
  </div>
  <div class="plans__description" *ngIf="selectedPlan?.plan">
    <h2>
      {{
        '+INSTALLATIONS.INSTALLATION.VICARE_PLANS.' + selectedPlan.plan + '.TITLE'
          | uppercase
          | translate
      }}
    </h2>
    <p>
      {{
        '+INSTALLATIONS.INSTALLATION.VICARE_PLANS.' + selectedPlan.plan + '.DESCRIPTION'
          | uppercase
          | translate
      }}
    </p>
  </div>
  <div class="plans__features">
    <div
      class="feature"
      [class.feature--disabled]="!feature.supported"
      *ngFor="let feature of selectedPlan?.features"
    >
      <p class="feature__title">
        {{
          '+INSTALLATIONS.INSTALLATION.VICARE_PLANS.FEATURES.' + feature.name + '.TITLE'
            | uppercase
            | translate
        }}
        <mat-icon
          *ngIf="feature.reason"
          class="mat-icon--sm"
          [matTooltip]="feature.reason"
          [matIconHeightSmall]
          matTooltipPosition="above"
        >
          info_outline
        </mat-icon>
      </p>
      <p>
        {{
          '+INSTALLATIONS.INSTALLATION.VICARE_PLANS.FEATURES.' + feature.name + '.DESCRIPTION'
            | uppercase
            | translate
        }}
      </p>
    </div>
  </div>
</ng-container>
